import { t } from "../../hooks/useAppTranslation";
import React from 'react';
import {SimpleDocumentsListWithFetch} from '../documents';
import * as ControlFunctions from '../ManageControlCommons/ManageControlCommons';
import './ExternalControlDetail.scss';
import {AuditDetail} from '../AuditDetail/AuditDetail';

export const ExternalControlDetailInfo = props => {

	const controlInfoItem = (label, value) => {
		return (<div className='row mt-3'>
			<div className='col-md-3 input-label'>{t(label)}:</div>
			<div className='col-md-9'>{value}</div>
		</div>)
	};

	const pzpControls = (pzpControls) => {
		return (
			<>
				<table className='internal-table'>
					<thead>
					<tr>
						<td>{t('external-controls-control-kind')}</td>
						<td>{t('external-controls-contract-notice-number')}</td>
						<td>{t('external-controls-contract-number')}</td>
					</tr>
					</thead>
					<tbody>
					{pzpControls && pzpControls.map(pzp => {
						return <tr key={pzp.contractNumber}>
							<td>{pzp.type}</td>
							<td>{pzp.number}</td>
							<td>{pzp.contractNumber}</td>
						</tr>
					})}
					</tbody>
				</table>
			</>
		)
	};

	const consequences = (consequences) => {
		return (
			<>
				<table className='internal-table'>
					<thead>
					<tr>
						<td>{t('external-controls-correction-type')}</td>
						<td>{t('external-controls-legal-basis-infringement')}</td>
						<td>{t('external-controls-contract-number')}</td>
						<td>{t('external-controls-basis-calculating-correction')}</td>
						<td>{t('external-controls-correction-rate')}</td>
						<td>{t('external-controls-value-financial-correction')}</td>
					</tr>
					</thead>
					<tbody>
					{consequences && consequences.map(c => {
						return <tr key={c.contractNumber}>
							<td>{c.type}</td>
							<td>{c.lawBase}</td>
							<td>{c.contractNumber}</td>
							<td>{c.correctionAccural}</td>
							<td>{c.correctionPercent}</td>
							<td>{c.correctionValue}</td>
						</tr>
					})}
					</tbody>
				</table>
			</>
		)
	};

	const renderControlInfo = (control) => {
		ControlFunctions.getExternalControlData(control);
	return (
		<>
			<h4 className='mt-5'>{t('external-controls-project-details')}: </h4>
			<div className='row'>
				<div className='col-md-12'>
				{controlInfoItem('external-controls-control-number', control.number)}
				{controlInfoItem('external-controls-project-number', control.project?.number)}
				{controlInfoItem('external-controls-project-title', control.project?.name)}
				</div>
			</div>
			<h4 className='mt-5'>{t('external-controls-beneficiary-data')}: </h4>
			<div className='row'>
				<div className='col-md-12'>
				{controlInfoItem('external-controls-beneficiary-id', control.project?.beneficiaryIdentityNumber)}
				{controlInfoItem('external-controls-beneficiary-name', control.project?.beneficiaryName)}
				{controlInfoItem('external-controls-beneficiary-address', control.project?.beneficiaryAddress)}

				</div>
			</div>
			<h4 className='mt-5'>{t('external-controls-details-control')}: </h4>
			<div className='row'>
				<div className='col-md-12'>
				{controlInfoItem('external-controls-reference-control-number', control.ownnumber)}
				{controlInfoItem('external-controls-control-date', control.plannedTerm)}
				{controlInfoItem('external-controls-control-type', control.type)}
				{control.typeDescription && controlInfoItem('external-controls-control-type-description', control.typeDescription)}
				{controlInfoItem('external-controls-controlling-body', control.controllingSubject)}
				{controlInfoItem('external-controls-controlled-entities', control.subjectsList)}
				{controlInfoItem('external-controls-control-result', control.controlResult)}
				{controlInfoItem('external-controls-control-result-description', control.description)}
				</div>
			</div>
			{control.pzpControls.length !== 0 && (
				<div className='blue-line'>
					<div className="framed-part framed-part--first">
						<h4 className="framed-part__title">{t('external-controls-public-procurement-controls')}</h4>
						{pzpControls(control.pzpControls)}
					</div>
				</div>
			)}

			<div className='blue-line'>
				<div className="framed-part framed-part--first">
					<h4 className="framed-part__title">{t('external-controls-files-attached-control')}</h4>
					<SimpleDocumentsListWithFetch controlUuid={control.uuid} />
				</div>
			</div>

			{control.hasConsequences && (
				<div className='blue-line'>
					<div className="framed-part framed-part--first">
						<h4 className="framed-part__title">{t('external-controls-consequences-financial')}</h4>
						{consequences(control.consequences)}
					</div>
				</div>
			)}

			{control.audit && (
				<div className='mt-5 blue-line' style={{ paddingBottom: '3rem'}}>
					<h4 className='mt-4'>{t('external-controls-audit-data')}:</h4>
					<AuditDetail
						auditData={{
							createdOn: control.audit.createdOn,
							createdByLogin: control.audit.createdByLogin,
							createdBy: control.audit.createdBy,
							updatedOn: control.audit.updatedOn,
							updatedByLogin: control.audit.updatedByLogin,
							updatedBy: control.audit.updatedBy,
						}}>
					</AuditDetail>
				</div>
			)}
		</>
		);
	};

	let controlInfo = props.control;
	return (
		<>
			{controlInfo && renderControlInfo(controlInfo)}
		</>
	);
};
